$(document).ready(function () {

    var modals = $('.modal');
    var body = $('body');

    modals.remove();
    body.append(modals);
});

 // change min-host-card modal's background to white
$(document).ready(function () {
    $('#ModalMinicard').on('shown.bs.modal', function () {
        $('.modal-backdrop').addClass('backdrop-white');
    });
});